module.exports = __webpack_public_path__ + "media/images/redesign-images/sorority/sorority-3-medium-d94e3eed3ac7b4aa0edd0d845a93cbb0.jpg";